// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.skeleton-podcast-row {
  margin-bottom: 15px;
  --padding-start: 16px;
}
.skeleton-podcast-row__cover {
  width: 56px;
  height: 56px;
  margin-inline-end: 12px;
  border-radius: 8px;
  overflow: hidden;
}
.skeleton-podcast-row__cover ion-skeleton-text {
  width: 100%;
  height: 100%;
  margin: 0;
  border-radius: 8px;
}
.skeleton-podcast-row__label {
  margin: 0;
}
.skeleton-podcast-row__line {
  margin: 0 0 8px;
}
.skeleton-podcast-row__line ion-skeleton-text {
  margin: 0;
  height: 16px;
}
.skeleton-podcast-row__line--title ion-skeleton-text {
  width: 78%;
}
.skeleton-podcast-row__line--meta ion-skeleton-text {
  width: 44%;
  height: 14px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/podcast/skeleton-podcast-row/skeleton-podcast-row.component.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,qBAAA;AACF;AACE;EACE,WAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;AACJ;AACI;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;AACN;AAGE;EACE,SAAA;AADJ;AAIE;EACE,eAAA;AAFJ;AAII;EACE,SAAA;EACA,YAAA;AAFN;AAKI;EACE,UAAA;AAHN;AAMI;EACE,UAAA;EACA,YAAA;AAJN","sourcesContent":[".skeleton-podcast-row {\n  margin-bottom: 15px;\n  --padding-start: 16px;\n\n  &__cover {\n    width: 56px;\n    height: 56px;\n    margin-inline-end: 12px;\n    border-radius: 8px;\n    overflow: hidden;\n\n    ion-skeleton-text {\n      width: 100%;\n      height: 100%;\n      margin: 0;\n      border-radius: 8px;\n    }\n  }\n\n  &__label {\n    margin: 0;\n  }\n\n  &__line {\n    margin: 0 0 8px;\n\n    ion-skeleton-text {\n      margin: 0;\n      height: 16px;\n    }\n\n    &--title ion-skeleton-text {\n      width: 78%;\n    }\n\n    &--meta ion-skeleton-text {\n      width: 44%;\n      height: 14px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
